import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const authRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'change-temporary-password',
    loadComponent: () =>
      import('./features/change-temporary-password/change-temporary-password.page').then(
        (m) => m.ChangeTemporaryPasswordPage,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/forgot-password/forgot-password.page').then((m) => m.ForgotPasswordPage),
  },
  {
    path: 'select-access',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/select-access/select-access.page').then((m) => m.SelectAccessPage),
  },
];
